import React, { Component, useState } from 'react'

import { connect, useDispatch } from 'react-redux'
import { notify } from 'Actions/notifications'
import { openModal } from '../../../actions/ui'
import { useStripe } from '@stripe/react-stripe-js'
import { setCurrentUser } from 'Actions/user'
import moment from 'moment'

import StripeElementsWrapper from '@components/StripeElementsWrapper'

import './PaymentMeans.sass'
import axios from 'axios'
import { sumBy } from 'lodash'
import Button from '../../ui/Button'

class PaymentMeansPage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      unpaidInvoices: [],
      paymentMeanExpiration: null,
    }
  }

  componentDidMount() {
    if (this.props.currentUser.unpaidInvoices.length > 0) {
      this.getUnpaidInvoices()
    }

    this.getPaymentMeanExpiration()
  }

  checkPaymentsStatuses() {
    const { dispatch, currentUser } = this.props

    fetch(`/api/user/${currentUser.id}/check-invoices-paid`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
    })
      .then(res => {
        if (res.status !== 200) throw new Error(res.error)

        dispatch(
          notify(
            'success',
            'Tous les paiements en attente ont été validés. Réactivation de votre compte...',
          ),
        )

        return res
      })
      .then(res => res.json())
      .then(user => dispatch(setCurrentUser(user)))
  }

  async getUnpaidInvoices() {
    const { currentUser, dispatch } = this.props

    try {
      const res = await axios.get(`/api/user/${currentUser.id}/unpaid-invoices`)

      this.setState({
        unpaidInvoices: res.data
      })
    } catch (e) {
      console.log('e --------------------------------->')
      console.log(e)
      dispatch(notify('error', 'Une erreur est survenue lors de la récupération de vos factures impayées, merci de contacter notre service clients.'))
    }
  }

  async getPaymentMeanExpiration() {
    const { currentUser } = this.props

    try {
      const res = await axios.get(`/api/user/${currentUser.id}/payment-mean-expiration`)

      this.setState({
        paymentMeanExpiration: res.data.expiration
      })
    } catch (e) {
      console.log('e --------------------------------->')
      console.log(e)
    }
  }

  renderRetryUnpaidInvoices() {
    const { currentUser } = this.props
    const { unpaidInvoices, paymentMeanExpiration } = this.state
    if (currentUser.unpaidInvoices.length === 0) return null
    if (!unpaidInvoices.length) return (
      <div className="flex justify-center align-center pt-6">
        <img height="30px" src="/assets/images/spinner.gif" alt="Veuillez patienter" />
      </div>
    )

    const total = sumBy(unpaidInvoices, i => i.total)
    const formattedTotal = (total / 100).toFixed(2).replace('.', ',')

    const isPaymentMeanExpired = paymentMeanExpiration && moment(paymentMeanExpiration, 'MM/YYYY').endOf('month').isBefore(moment())

    const content = isPaymentMeanExpired ? (
      <div className="mb-8">
        Votre moyen de paiement enregistré est expiré, merci d'en renseigner un nouveau à l’aide du bouton ci-dessous
      </div>
    ) : (
      <>
        <div className="mb-4">
          Si vous avez réapprovisionné votre moyen de paiement enregistré, cliquez sur le bouton ci-dessous pour retenter le paiement.
        </div>
        <div className="mb-8 flex justify-center">
          <RetryPaymentsButtonWithStripe user={currentUser} onSuccess={() => this.checkPaymentsStatuses()} />
        </div>
      </>
    )

    return (
      <>
        <div className="means-title">Retenter le paiement</div>
        <div className="">{unpaidInvoices.length} facture{unpaidInvoices.length > 1 ? 's' : ''} {unpaidInvoices.length > 1 ? 'sont' : 'est'} en attente de paiement, pour un montant total de {formattedTotal} € TTC.</div>
        {content}
      </>
    )
  }

  renderTaking() {
    const { openCbModal, currentUser = {} } = this.props
    const { paymentMeanExpiration } = this.state
    const { last4, sepa_ok } = currentUser
    const paymentMean = sepa_ok ? 'prélèvement' : 'carte bancaire'
    const expiration = paymentMeanExpiration ? `  (expire le ${paymentMeanExpiration})` : ''

    return (
      <div className="means-page">
        <div className="means-container">
          <div className="means-subtitle">Paiement par {paymentMean}</div>
          <div className="means-fields">
            <input
              name="number"
              type="text"
              className="Input-group"
              value={`XXXX XXXX XXXX ${last4}${expiration}`}
              disabled
            />
          </div>
        </div>
        <div onClick={openCbModal} className="btn primary connexion-btn">
          Modifier
        </div>
      </div>
    )
  }

  render() {
    return (
      <>
        {this.renderRetryUnpaidInvoices()}
        <div className="means-title">Moyen de paiement</div>
        {this.renderTaking()}
      </>
    )
  }
}

const RetryPaymentsButtonWithStripe = ({ user, onSuccess }) => {
  return (
    <StripeElementsWrapper user={user}>
      <RetryPaymentsButton user={user} onSuccess={onSuccess} />
    </StripeElementsWrapper>
  )
}

const RetryPaymentsButton = ({ user, onSuccess }) => {
  const [isSubmitting, setSubmitting] = useState(false)
  const stripe = useStripe()
  const dispatch = useDispatch()

  const attemptPayInvoices = async () => {
    setSubmitting(true)

    try {
      const res = await axios.post(`/api/user/${user.id}/attempt-pay-invoices`)

      if (res.data.pendingPayments) {
        handleSuccessivePayments(res.data.pendingPayments)
      } else {
        setSubmitting(false)
        onSuccess()
      }

    } catch (e) {
      console.log('e --------------------------------->')
      console.log(e)
      setSubmitting(false)
      dispatch(notify('error', 'Le paiement a échoué'))
    }
  }

  const handleSuccessivePayments = (secrets, step = 0) => {
    stripe.handleCardPayment(secrets[step], {}).then(res => {
      if (res.error) {
        dispatch(
          notify('error', 'Paiement refusé, veuillez vérifier l’approvisionnement de votre carte.'),
        )
        setSubmitting(false)

        return
      }

      if (step < secrets.length - 1) {
        dispatch(notify('success', 'Paiement validé'))
        handleSuccessivePayments(secrets, step + 1)

        return
      }

      onSuccess()
    })
  }

  if (isSubmitting) {
    return <img height="30px" src="/assets/images/spinner.gif" alt="Veuillez patienter" />
  }

  return (
    <Button label="Lancer le paiement" onClick={() => attemptPayInvoices()} secondaryClass="primary" />
  )
}

const MapStateToProps = state => ({
  currentUser: state.user.currentUser,
})

const MapDispatchToProps = dispatch => ({
  openCbModal: () => dispatch(openModal('editCB')),
  dispatch,
})

export default connect(MapStateToProps, MapDispatchToProps)(PaymentMeansPage)
